(function () {
  var configEl  = document.getElementById("bogo-config");
  var overlay   = document.getElementById("bogo-overlay");
  var popup     = document.getElementById("bogo-popup");
  var dismissBtn = document.getElementById("bogo-dismiss");
  var nameEl    = document.getElementById("bogo-collection-name");
  var ctaEl     = document.getElementById("bogo-cta");

  if (!configEl || !popup || !overlay) return;

  var config = {};
  try { config = JSON.parse(configEl.textContent); } catch (e) { return; }

  var productIds = (config.productIds || []).map(String);
  if (!productIds.length) return;

  if (nameEl) nameEl.textContent = config.collectionName || "";
  if (ctaEl && config.collectionUrl) ctaEl.href = config.collectionUrl;

  // ── show / hide ───────────────────────────────────────────────────────────

  var showTimer = null;
  var STORAGE_KEY = "bogo_dismissed";

  function isDismissed() {
    try { return sessionStorage.getItem(STORAGE_KEY) === "1"; } catch (e) { return false; }
  }

  function setDismissed() {
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (e) {}
  }

  function clearDismissed() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function show() {
    overlay.style.display = "block";
    popup.style.display   = "block";
    overlay.classList.remove("bogo-animate");
    popup.classList.remove("bogo-animate");
    void popup.offsetWidth;
    overlay.classList.add("bogo-animate");
    popup.classList.add("bogo-animate");
  }

  function scheduleShow() {
    clearTimeout(showTimer);
    showTimer = setTimeout(show, 3000);
  }

  function hide() {
    clearTimeout(showTimer);
    showTimer = null;
    overlay.style.display = "none";
    popup.style.display   = "none";
  }

  dismissBtn.addEventListener("click", function () {
    setDismissed();
    hide();
  });

  overlay.addEventListener("click", function () {
    setDismissed();
    hide();
  });

  // CTA click — mark dismissed so redirect doesn't re-trigger popup on next page
  if (ctaEl) {
    ctaEl.addEventListener("click", function () {
      setDismissed();
    });
  }

  // ── cart helpers ──────────────────────────────────────────────────────────

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  function isGift(item) {
    return !!((item.properties || {})["_gwp"]);
  }

  function countQualifying(cart) {
    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (isGift(item)) return;
      if (productIds.indexOf(String(item.product_id)) !== -1) {
        total += item.quantity;
      }
    });
    return total;
  }

  // ── reconciler ────────────────────────────────────────────────────────────

  var busy   = false;
  var queued = false;

  function check() {
    if (busy) { queued = true; return; }
    busy   = true;
    queued = false;

    getCart()
      .then(function (cart) {
        var count = countQualifying(cart);
        if (count === 1) {
          if (!isDismissed()) scheduleShow();
        } else {
          // Cart no longer has exactly 1 item — reset so popup can show again next time
          clearDismissed();
          hide();
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (queued) setTimeout(check, 0);
      });
  }

  // ── intercept cart mutations ──────────────────────────────────────────────

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(check, 300);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ""));
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input || {}).url;
    var p = _fetch.apply(this, arguments);
    if (isCartMutation(url)) p.then(schedule, schedule);
    return p;
  };

  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this._bogoWatch = isCartMutation(url);
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._bogoWatch) this.addEventListener("loadend", schedule);
    return _send.apply(this, arguments);
  };

  // ── initial check ─────────────────────────────────────────────────────────

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", check);
  } else {
    check();
  }
})();
